import { Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Strengths from './pages/Strengths';
import Services from './pages/Services';
import References from './pages/References';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

export default function App() {
  return (
    <div className="flex flex-col min-h-screen bg-stone-50 text-stone-900 antialiased selection:bg-accent selection:text-white">
      {/* Scroll Restoration */}
      <ScrollToTop />

      {/* Header / Navigation */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/om-os/vores-styrker" element={<Navigate to="/vores-styrker" replace />} />
          <Route path="/vores-styrker" element={<Strengths />} />
          
          {/* Services Main Page */}
          <Route path="/vi-tilbyder" element={<Services />} />
          
          {/* 1. Udhuse & Subpages */}
          <Route path="/vi-tilbyder/udhuse" element={<Services />} />
          <Route path="/vi-tilbyder/udhuse/:subpage" element={<Services />} />
          
          {/* 2. Tilbygning */}
          <Route path="/vi-tilbyder/tilbygning" element={<Services />} />
          
          {/* 3. Nybyggeri i træ & Subpages */}
          <Route path="/vi-tilbyder/nybyggeri-i-trae" element={<Services />} />
          <Route path="/vi-tilbyder/nybyggeri-i-trae/:subpage" element={<Services />} />
          <Route path="/vi-tilbyder/sommerhus" element={<Services />} />
          <Route path="/vi-tilbyder/helaarshus" element={<Services />} />
          
          {/* 4. Totalrenovering */}
          <Route path="/vi-tilbyder/totalrenovering" element={<Services />} />
          
          {/* Legacy route for Ombygning -> render Services or redirect */}
          <Route path="/vi-tilbyder/ombygning" element={<Services />} />
          
          {/* 5. Service & Subpages */}
          <Route path="/vi-tilbyder/service" element={<Services />} />
          <Route path="/vi-tilbyder/service/:subpage" element={<Services />} />
          
          {/* Referencer & Kontakt */}
          <Route path="/referencer" element={<References />} />
          <Route path="/galleri" element={<References />} />
          <Route path="/kontakt" element={<Contact />} />

          {/* Error Pages */}
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
